module.exports = __webpack_public_path__ + "img/sm.f1423f88.svg";